export const cdn = (path) => {
  return `https://storage.googleapis.com/inaq_sk_pictures_landing_pages${path}`;
};
